import { render } from "./UpdateQueueView.vue?vue&type=template&id=2af4a157"
import script from "./UpdateQueueView.vue?vue&type=script&lang=js"
export * from "./UpdateQueueView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__